"use client"

import { useQueryState } from "nuqs"
import { Button } from "@/components/atoms/Button/button"
import { useModalStore } from "@/hooks/useModal"
import useLocaleStore from "@/app/stores/useLocaleStore"

type ReviewButtonProps = {
  productId: string
  type: "product" | "consultant"
}

export const ReviewButton = ({ productId, type }: ReviewButtonProps) => {
  const { openModal } = useModalStore()
  const [_pid, setPid] = useQueryState("pid")
  const [_type, setType] = useQueryState("type")
  const lang = useLocaleStore().locale

  return (
    <Button
      onClick={() => {
        setPid(productId)
        setType(type)
        openModal("review")
      }}
    >
      {lang === "am" ? "ሀሳብ ይስጡ" : "Leave a Review"}
    </Button>
  )
}
